<template>
  <div class="question">
    <div class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('navigation.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('navigation.question') }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="go-back">
        <img @click="goBack" src="@/assets/icons/left.svg" alt="">
        <span @click="goBack">{{ $t('navigation.goBack') }}</span>
      </div>
      <div class="section-2">
        <div class="title">
          {{ $t('question.pageTitle') }}
        </div>
        <div class="content">{{ $t('question.pageDesc') }}</div>
        <el-collapse>
          <el-collapse-item v-for="item in questionList" :key="item.title" :name="item.title" :title="item.title">
            <div v-if="item.causes" class="causes-wrapper">
              <div v-for="(cause, index) in item.causes" :key="index" class="cause-item">
                <div class="cause-title">{{ getLetterPrefix(index) }}. {{ cause.title }}</div>
                <div class="cause-reason"><span class="roman-number">i.</span> {{ $t('question.causeLabel') }}{{ cause.reason }}</div>
                <div class="solution-content">
                  <div v-if="cause.solutions.length === 1" class="solution-inline">
                    <span class="roman-number">ii.</span> {{ $t('question.solutionLabel') }}{{ cause.solutions[0] }}
                  </div>
                  <template v-else>
                    <div class="solution-title"><span class="roman-number">ii.</span> {{ $t('question.solutionLabel') }}</div>
                    <div v-for="(solution, sIndex) in cause.solutions" :key="sIndex" class="solution-item">{{ solution }}</div>
                  </template>
                </div>
              </div>
            </div>
            <div v-else-if="item.reason" class="simple-problem">
              <div class="cause-reason"><span class="roman-number">i.</span> {{ $t('question.causeLabel') }}{{ item.reason }}</div>
              <div class="solution-content">
                <div class="solution-inline">
                  <span class="roman-number">ii.</span> {{ $t('question.solutionLabel') }}{{ item.solution }}
                </div>
              </div>
            </div>
            <div v-else-if="item.products" class="products-wrapper">
              <div v-for="(product, index) in item.products" :key="index" class="product-item">
                <div class="product-title">{{ getLetterPrefix(index) }}. {{ product.title }}</div>
                <div v-for="(solution, sIndex) in product.solutions" :key="sIndex" class="product-solution"><span class="roman-number">{{ getRomanNumber(sIndex) }}.</span> {{ solution }}</div>
                <video v-if="product.video" width="300px" height="150px" :src="product.video" controls></video>
              </div>
            </div>
            <video v-if="item.video" width="300px" height="150px" :src="item.video" controls></video>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="section-3">
      <div class="container">
        <div class="title">{{ $t('question.questionTitle') }}</div>
        <div class="content">{{ $t('question.questionDesc') }}</div>
        <div class="contact-info">
          <!-- <div v-if="lang === 'zh'" class="info-item">
            <img src="@/assets/icons/Phone-2.svg" alt="">
            <span class="info-title">{{ $t('question.questionPhone') }}：</span>
            <span class="info-content">400-XXX-XXXX</span>
          </div> -->
          <div class="info-item">
            <img src="@/assets/icons/Mail-2.svg" alt="">
            <span class="info-title">{{ $t('question.questionEmail') }}：</span>
            <span class="info-content">support@shokz.com</span>
          </div>
          <div v-if="lang === 'zh'" class="info-item">
            <img src="@/assets/icons/CustomerService.svg" alt="">
            <span class="info-title">{{ $t('question.questionOnline') }}：</span>
            <span class="info-content">{{ $t('question.questionOnlineTime') }}</span>
          </div>
        </div>
        <div class="contact-tips">
          <div class="title">{{ $t('question.questionContact') }}</div>
          <ul class="tips-list">
            <li>{{ $t('question.questionDesc1') }}</li>
            <li>{{ $t('question.questionDesc2') }}</li>
            <li>{{ $t('question.questionDesc3') }}</li>
            <li>{{ $t('question.questionDesc4') }}</li>
          </ul>
        </div>
        <div class="btn" @click="showFeedback">{{ $t('question.submitBtn') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/lang';
export default {
  data() {
    return {
      
    };
  },
  computed: {
    lang() {
      return i18n.locale;
    },
    questionList() {
      return [
        {
          title: this.$t('question.problem1Title'),
          causes: [
            {
              title: this.$t('question.problem1Cause1Title'),
              reason: this.$t('question.problem1Cause1Reason'),
              solutions: [
                this.$t('question.problem1Cause1Solution1'),
                this.$t('question.problem1Cause1Solution2'),
                this.$t('question.problem1Cause1Solution3')
              ]
            },
            {
              title: this.$t('question.problem1Cause2Title'),
              reason: this.$t('question.problem1Cause2Reason'),
              solutions: [
                this.$t('question.problem1Cause2Solution')
              ]
            }
          ],
          video: this.lang === 'zh' ? '/videos/question/zh/1.mp4' : '/videos/question/en/1.mp4',
        },
        {
          title: this.$t('question.problem2Title'),
          causes: [
            {
              title: this.$t('question.problem2Cause1Title'),
              reason: this.$t('question.problem2Cause1Reason'),
              solutions: [
                this.$t('question.problem2Cause1Solution1'),
                this.$t('question.problem2Cause1Solution2'),
                this.$t('question.problem2Cause1Solution3')
              ]
            },
            {
              title: this.$t('question.problem2Cause2Title'),
              reason: this.$t('question.problem2Cause2Reason'),
              solutions: [
                this.$t('question.problem2Cause2Solution')
              ]
            }
          ],
          video: this.lang === 'zh' ? '/videos/question/zh/2.mp4' : '/videos/question/en/2.mp4',
        },
        {
          title: this.$t('question.problem3Title'),
          causes: [
            {
              title: this.$t('question.problem3Cause1Title'),
              reason: this.$t('question.problem3Cause1Reason'),
              solutions: [
                this.$t('question.problem3Cause1Solution')
              ]
            },
            {
              title: this.$t('question.problem3Cause2Title'),
              reason: this.$t('question.problem3Cause2Reason'),
              solutions: [
                this.$t('question.problem3Cause2Solution')
              ]
            },
            {
              title: this.$t('question.problem3Cause3Title'),
              reason: this.$t('question.problem3Cause3Reason'),
              solutions: [
                this.$t('question.problem3Cause3Solution')
              ]
            },
            {
              title: this.$t('question.problem3Cause4Title'),
              reason: this.$t('question.problem3Cause4Reason'),
              solutions: [
                this.$t('question.problem3Cause4Solution')
              ]
            }
          ],
          video: this.lang === 'zh' ? '/videos/question/zh/3.mp4' : '/videos/question/en/3.mp4',
        },
        {
          title: this.$t('question.problem4Title'),
          causes: [
            {
              title: this.$t('question.problem4Cause1Title'),
              reason: this.$t('question.problem4Cause1Reason'),
              solutions: [
                this.$t('question.problem4Cause1Solution1'),
                this.$t('question.problem4Cause1Solution2'),
                this.$t('question.problem4Cause1Solution3')
              ]
            },
            {
              title: this.$t('question.problem4Cause2Title'),
              reason: this.$t('question.problem4Cause2Reason'),
              solutions: [
                this.$t('question.problem4Cause2Solution')
              ]
            },
            {
              title: this.$t('question.problem4Cause3Title'),
              reason: this.$t('question.problem4Cause3Reason'),
              solutions: [
                this.$t('question.problem4Cause3Solution')
              ]
            }
          ]
        },
        {
          title: this.$t('question.problem5Title'),
          causes: [
            {
              title: this.$t('question.problem5Cause1Title'),
              reason: this.$t('question.problem5Cause1Reason'),
              solutions: [
                this.$t('question.problem5Cause1Solution')
              ]
            },
            {
              title: this.$t('question.problem5Cause2Title'),
              reason: this.$t('question.problem5Cause2Reason'),
              solutions: [
                this.$t('question.problem5Cause2Solution')
              ]
            }
          ],
          video: this.lang === 'zh' ? '/videos/question/zh/5.mp4' : '/videos/question/en/5.mp4',
        },
        {
          title: this.$t('question.problem6Title'),
          causes: [
            {
              title: this.$t('question.problem6Cause1Title'),
              reason: this.$t('question.problem6Cause1Reason'),
              solutions: [
                this.$t('question.problem6Cause1Solution')
              ]
            },
            {
              title: this.$t('question.problem6Cause2Title'),
              reason: this.$t('question.problem6Cause2Reason'),
              solutions: [
                this.$t('question.problem6Cause2Solution')
              ]
            }
          ]
        },
        {
          title: this.$t('question.problem7Title'),
          reason: this.$t('question.problem7Reason'),
          solution: this.$t('question.problem7Solution')
        },
        {
          title: this.$t('question.problem8Title'),
          products: [
            {
              title: this.$t('question.problem8Product1'),
              solutions: [
                this.$t('question.problem8Product1Solution1'),
                this.$t('question.problem8Product1Solution2')
              ],
              video: this.lang === 'zh' ? '/videos/question/zh/8_1.m4v' : '/videos/question/en/8_1.m4v',
            },
            {
              title: this.$t('question.problem8Product2'),
              solutions: [
                this.$t('question.problem8Product2Solution1'),
                this.$t('question.problem8Product2Solution2')
              ],
              video: this.lang === 'zh' ? '/videos/question/zh/8_2.mp4' : '/videos/question/en/8_2.mp4',
            }
          ],
        }
      ];
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/' });
    },
    showFeedback() {
      this.$bus.$emit('showFeedback');
    },
    getLetterPrefix(index) {
      // 返回 a, b, c, d...
      return String.fromCharCode(97 + index);
    },
    getRomanNumber(index) {
      // 返回 i, ii
      const romanNumerals = ['i', 'ii', 'iii', 'iv', 'v'];
      return romanNumerals[index] || (index + 1);
    }
  }
}
</script>

<style lang='scss' scoped>
::v-deep .el-collapse {
  border: none;
  .el-collapse-item__header {
    height: 21px;
    line-height: 21px;
    color:#404040;
    font-size: 16px;
    padding-bottom: 16px;
    box-sizing: content-box;
  }
  .el-collapse-item {
    padding-bottom: 24px;
  }
  .el-collapse-item__content {
    padding-bottom: 16px;
  }

  .causes-wrapper, .simple-problem, .products-wrapper {
    font-size: 16px;
    line-height: 130%;
    color: #737373;
  }
  
  .cause-item, .product-item {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .cause-title, .product-title {
    font-weight: 500;
    color: #404040;
    margin-bottom: 8px;
  }
  
  .cause-reason {
    margin-bottom: 8px;
    padding-left: 20px;
  }
  
  .roman-number {
    margin-right: 4px;
  }
  
  .solution-content {
    padding-left: 20px;
    .solution-inline {
      margin-bottom: 4px;
    }
    .solution-title {
      margin-bottom: 4px;
    }
    .solution-item {
      margin-bottom: 4px;
      padding-left: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  
  .product-solution {
    margin-bottom: 4px;
    padding-left: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.section-3 {
 padding: 64px 0px 80px;
 background-image: url('~@/assets/images/question_bg_pc.webp');
 background-size: cover;
 background-position: center;
 .title {
  font-size: 36px;
  line-height: 110%;
  margin-bottom: 16px;
  color: #0A0A0A;
  font-weight: 500;
 }
 .content {
  font-size: 18px;
  line-height: 120%;
  margin-bottom: 16px;
  color: #404040;
 }
 .contact-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 48px;
  .info-item {
    display: flex;
    align-items: center;
    
    img{
      width: 20px;
      margin-right: 20px;
    }
    .info-title {
      font-size: 16px;
      line-height: 130%;
      font-weight: 500;
      color: #404040;
      margin-right: 11px;
    }
    .info-content {
      font-size: 16px;
      line-height: 130%;
      font-weight: 400;
      color: #737373;
    }
  }
 }
 .contact-tips {
    margin-bottom: 48px;
    .title {
      font-size: 18px;
      line-height: 120%;
      margin-bottom: 16px;
      color: #404040;
    }
    .tips-list {
      font-size: 16px;
      line-height: 130%;
      font-weight: 400;
      color: #737373;
      list-style: disc;
      margin-left: 0px;
      li{
        margin-bottom: 8px;
        list-style: disc;
      }
    }
  }
  .btn {
    font-size: 16px;
    line-height: 130%;
    font-weight: 500;
    color: #fff;
    padding: 10px 20px;
    border-radius: 4px;
    background-color: #0A0A0A;
    display: inline-block;
  }
}
@media screen and (max-width: 850px) {
  ::v-deep .el-collapse {
    .el-collapse-item__header {
      height: 19px;
      line-height: 19px;
      color:#404040;
      font-size: 15x;
    }
    .question-content {
      font-size: 15px;
      margin-bottom: 8px;
    }
    .solution-content {
      font-size: 15px;
    }
  }
  .section-3 {
    padding: 56px 0px;
    background-image: url('~@/assets/images/question_bg_mb.webp');
    .title {
      font-size: 24px;
      line-height: 120%;
    }
    .content {
      font-size: 16px;
      line-height: 130%;
    }
    .contact-info {
      margin-bottom: 32px;
      .info-item {
        .info-content {
          font-size: 14px;
        }
      }
    }
    .contact-tips {
        margin-bottom: 32px;
        .tips-list {
          font-size: 14px;
          margin-left: 4px;
        }
      }
  }
}
</style>